import { render, staticRenderFns } from "./RolesSidebar.vue?vue&type=template&id=241c3a36&scoped=true&"
import script from "./RolesSidebar.vue?vue&type=script&lang=js&"
export * from "./RolesSidebar.vue?vue&type=script&lang=js&"
import style0 from "./RolesSidebar.vue?vue&type=style&index=0&id=241c3a36&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "241c3a36",
  null
  
)

export default component.exports